import styled from 'styled-components/macro';

// import theme helpers
import { getColor } from '../../../../util/theme';

const CtaBarWrapper = styled.div`
  width: 100vw;

  background-color: ${getColor('primaryBlue')};

  position: fixed;
  bottom: 0;

  border-top: 2px solid ${getColor('accentGreen')};
`;

export default CtaBarWrapper;
